import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import sound from "../../../../images/alaram.mp3";

const MobileCashorders = () => {
    const [isHovered, setIsHovered] = useState(false);
    const [expandedOrder, setExpandedOrder] = useState(null);
    const [orders, setOrders] = useState([]);
    const [checkedItems, setCheckedItems] = useState({});
    const [vendorId, setVendorId] = useState(null);
    const scrollContainerRef = useRef(null);
    const notificationSound = new Audio(sound);

    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        setVendorId(storedVendorId);
    }, []);

    useEffect(() => {
        if (!vendorId) return;

        let previousOrderIds = [];

        const fetchOrders = async () => {
            const token = localStorage.getItem("authToken");
            if (!token) return;

            try {
                const response = await axios.get(
                    `https://backend.maamaas.com/food/orders/getallorder/${vendorId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                const pendingOrders = response.data.filter(
                    (order) => order.cashStatus === 'PENDING'
                );

                const newOrderIds = pendingOrders.map((o) => o.orderId);
                const isNewOrder = newOrderIds.some((id) => !previousOrderIds.includes(id));

                if (isNewOrder) {
                    notificationSound.play().catch((e) => console.warn("Autoplay blocked:", e));
                }

                previousOrderIds = newOrderIds;
                setOrders(pendingOrders);
            } catch (error) {
                console.error("Fetch error:", error.response?.data || error.message);
            }
        };

        fetchOrders();
        const intervalId = setInterval(fetchOrders, 1000);

        return () => clearInterval(intervalId);
    }, [vendorId]);

    // Horizontal Auto-scroll
    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;

        let interval = setInterval(() => {
            if (!isHovered) {
                scrollContainer.scrollLeft += 1;
                if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
                    scrollContainer.scrollLeft = 0;
                }
            }
        }, 20);

        return () => clearInterval(interval);
    }, [isHovered]);

    const getOrderColor = (orderService) => {
        const type = (orderService || "").trim().toLowerCase();
        switch (type) {
            case "dine_in":
                return "#1E90FF";
            case "pick_up":
                return "#FF6347";
            case "delivery":
                return "#20B2AA";
            default:
                return "#ccc";
        }
    };

    const handleOrderClick = (order) => {
        setExpandedOrder(expandedOrder?.orderId === order.orderId ? null : order);
    };

    const handleCheckboxChange = (orderId, itemIndex) => {
        const key = `${orderId}-${itemIndex}`;
        setCheckedItems((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const handleAcceptOrder = async (e, orderId) => {
        e.stopPropagation();
        const token = localStorage.getItem("authToken");
        if (!token) return;

        try {
            await axios.put(
                `https://backend.maamaas.com/food/orders/editstatus/${orderId}`,
                { cashStatus: 'ACCEPT' },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setOrders((prev) => prev.filter((order) => order.orderId !== orderId));
        } catch (error) {
            console.error("Accept error:", error.response?.data || error.message);
        }
    };

    const handleDeclineOrder = async (e, orderId) => {
        e.stopPropagation();
        const token = localStorage.getItem("authToken");
        if (!token) return;

        try {
            await axios.put(
                `https://backend.maamaas.com/food/orders/editstatus/${orderId}`,
                { cashStatus: "CANCELLED" },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setOrders((prev) => prev.filter((order) => order.orderId !== orderId));
        } catch (error) {
            console.error("Decline error:", error.response?.data || error.message);
        }
    };

    return (
        <div>
            {/* Internal CSS */}
            <style>
                {`
                @media (min-width: 768px) {
                .order-card{
                display:none !important;
                }
               
                }

             
        @media (max-width: 768px) {
        
          .mobile-orders-wrapper {
            width: 100%;
            left: 0;
            right: 0;
        
            top: 0px;
            height: auto;
      
            padding: 10px;
            border-radius: 0;
          }

          .mobile-scroll-container {
            display: flex;
            flex-direction: row;
            overflow-x: auto;
            gap: 10px;
            padding-bottom: 10px;
            scroll-behavior: smooth;
            margin-top: 50px;
             -ms-overflow-style: none;     /* Internet Explorer and Edge */
  scrollbar-width: none;  
            
          }

          .order-card {
            flex-shrink: 0;
            // width: 250px;
            min-width: 250px;
          }
        }

        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }

        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        `}
            </style>

            <div
                className="mobile-orders-wrapper"
                style={{
                    position: "fixed",

                    right: "16px",
                    borderRadius: "8px",
                    padding: "10px",
                    marginTop: "40px",
                }}
            >
                <div
                    className="hide-scrollbar"
                    style={{
                        maxHeight: "600px",
                        overflowY: "auto",
                        paddingRight: "5px",
                        // marginTop: "30px",
                    }}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <div className="mobile-scroll-container" ref={scrollContainerRef}>
                        {orders.map((order, index) => (
                            <div
                                key={`${order.orderId}-${index}`}
                                onClick={() => handleOrderClick(order)}
                                className="card order-card"
                                style={{
                                    cursor: "pointer",
                                    marginBottom: "10px",
                                    background: getOrderColor(order.orderService),
                                    borderRadius: "8px",
                                    boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
                                    padding: "10px",
                                    position: "relative",
                                    transition: "all 0.3s ease",
                                    height:
                                        expandedOrder?.orderId === order.orderId ? "auto" : "120px",
                                }}
                            >
                                <div style={{ color: "#fff", fontWeight: "bold" }}>
                                    Order ID: #{order.orderId}
                                </div>
                                <div style={{ color: "#fff" }}>
                                    {order.orderService || "N/A"}
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        marginTop: "10px",
                                    }}
                                >
                                    <button
                                        onClick={(e) => handleAcceptOrder(e, order.orderId)}
                                        style={{
                                            padding: "8px",
                                            backgroundColor: "rgb(177 93 198)",
                                            color: "white",
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                            border: "none",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Accept
                                    </button>
                                    <button
                                        onClick={(e) => handleDeclineOrder(e, order.orderId)}
                                        style={{
                                            padding: "8px",
                                            backgroundColor: "rgb(177 93 198)",
                                            color: "white",
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                            border: "none",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Decline
                                    </button>
                                </div>
                                {expandedOrder?.orderId === order.orderId && (
                                    <div style={{ marginTop: "10px" }}>
                                        <h6 style={{ color: "#fff", fontSize: "18px" }}>Items:</h6>
                                        <ul
                                            style={{
                                                listStyle: "none",
                                                padding: 0,
                                                marginLeft: "10px",
                                                fontWeight: "bold",
                                            }}
                                        >
                                            {(order.items || order.order || []).map((item, idx) => (
                                                <li
                                                    key={idx}
                                                    style={{
                                                        color: "#000",
                                                        fontSize: "16px",
                                                        marginBottom: "4px",
                                                    }}
                                                >
                                                    <label
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "8px",
                                                        }}
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={!!checkedItems[`${order.orderId}-${idx}`]}
                                                            onClick={(e) => e.stopPropagation()}
                                                            onChange={() =>
                                                                handleCheckboxChange(order.orderId, idx)
                                                            }
                                                        />
                                                        {item.dishName} × {item.quantity}
                                                    </label>
                                                </li>
                                            ))}
                                        </ul>


                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileCashorders;
